import { useRef } from 'react'
import * as THREE from 'three'
import { COLORS } from '../../utils/constants'

export function Ground() {
  const groundRef = useRef<THREE.Mesh>(null)
  
  return (
    <group>
      {/* 主地面 - 反射地板 */}
      <mesh 
        ref={groundRef}
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, -1.7, 0]}
        receiveShadow
      >
        <circleGeometry args={[20, 64]} />
        <meshStandardMaterial 
          color="#1a1a2e"
          metalness={0.8}
          roughness={0.2}
          envMapIntensity={0.5}
        />
      </mesh>
      
      {/* 装饰环 - 金色 */}
      <mesh 
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, -1.69, 0]}
      >
        <ringGeometry args={[8, 8.2, 64]} />
        <meshStandardMaterial 
          color={COLORS.gold.bright}
          metalness={0.9}
          roughness={0.1}
          emissive={COLORS.gold.dark}
          emissiveIntensity={0.3}
        />
      </mesh>
      
      {/* 内环 */}
      <mesh 
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, -1.69, 0]}
      >
        <ringGeometry args={[4, 4.1, 64]} />
        <meshStandardMaterial 
          color={COLORS.gold.medium}
          metalness={0.9}
          roughness={0.1}
          emissive={COLORS.gold.dark}
          emissiveIntensity={0.2}
        />
      </mesh>
      
      {/* 雪地效果 - 白色斑点 */}
      {Array.from({ length: 50 }).map((_, i) => {
        const angle = Math.random() * Math.PI * 2
        const radius = 2 + Math.random() * 15
        const x = Math.cos(angle) * radius
        const z = Math.sin(angle) * radius
        const scale = 0.1 + Math.random() * 0.3
        
        return (
          <mesh
            key={`snow-${i}`}
            rotation={[-Math.PI / 2, 0, 0]}
            position={[x, -1.68, z]}
            scale={scale}
          >
            <circleGeometry args={[1, 16]} />
            <meshBasicMaterial 
              color="#ffffff"
              transparent
              opacity={0.3 + Math.random() * 0.3}
            />
          </mesh>
        )
      })}
      
    </group>
  )
}